import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "fv-row mb-9" }
const _hoisted_3 = { class: "label required mb-1" }
const _hoisted_4 = { class: "fv-plugins-message-container" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = { class: "indicator-label" }
const _hoisted_7 = { class: "indicator-progress" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_9 = {
  class: "text-center",
  style: {"font-size":"16px"}
}

import { ref, inject } from "vue";
import * as Yup from "yup";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useStore } from "@/store";
import axios from "axios";
import i18n from "@/core/plugins/i18n";
import { ErrorMessage, Field, Form } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgetPasswordForm',
  setup(__props) {

const store = useStore();
const showPage = inject<any>("showPage");
const formData = ref<any>({});
const submitButton = ref<HTMLButtonElement | null>(null);
const { t } = i18n.global;

const reset = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
});

const onResetPassword = async (values) => {
  await store.dispatch(Actions.LOGOUT);

  if (!submitButton.value) {
    return;
  }

  submitButton.value.disabled = true;
  submitButton.value.setAttribute("data-kt-indicator", "on");

  try {
    var resetUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/reset-password";
    if (window.location.href.includes("portal")) {
      resetUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/portal/reset-password";
    }
    await axios.post("/api/v1/auth/password/forgot", {
      email: values.email,
      ResetUrl: resetUrl,
    });
    // "Password reset link has been sent to your email."
    Swal.fire({
      text: t("tip.passwordResetLinkSent"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: "Ok!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    });

    showPage.value = "LoginPage";
  } catch (error) {
    Swal.fire({
      text: error,
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: "Try again!",
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
    // console.error(error);
  }

  submitButton.value.disabled = false;
  submitButton.value.setAttribute("data-kt-indicator", "off");
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_unref(Form), {
    class: "forgot-password-form",
    onSubmit: onResetPassword,
    "validation-schema": _unref(reset)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("title.resetPassword")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("fields.email")), 1),
        _createVNode(_unref(Field), {
          modelValue: formData.value.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
          tabindex: "1",
          class: "form-control form-control-lg form-control-solid",
          type: "text",
          name: "email",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
              name: "email",
              placeholder: _ctx.$t('tip.pleaseInput'),
              size: "large",
              tabindex: "1"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ErrorMessage), { name: "email" })
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          tabindex: "3",
          type: "submit",
          ref_key: "submitButton",
          ref: submitButton,
          id: "kt_sign_in_submit",
          class: "btn btn-lg w-100 mb-5 text-light",
          style: {"background-color":"#393d48","width":"298px","height":"53px"}
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("action.send")), 1),
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait")) + " ", 1),
            _hoisted_8
          ])
        ], 512),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPage.value = 'LoginPage'))
          }, _toDisplayString(_ctx.$t("action.backToLogin")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}
}

})